const CUSTOM_CONSENT_MANAGER_PLUGIN = 'CustomConsentManagerPlugin';

export { CUSTOM_CONSENT_MANAGER_PLUGIN };
